import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";
import InputFormGroup from "components/Form/InputFormGroup";
import Formsy from 'formsy-react';
import {Col, Button, Alert} from "reactstrap";
import Loading from "components/Loading";

class ForgottenPassword extends React.Component {
    static propTypes = {
        onFormSubmit: PropTypes.func.isRequired,
        status: PropTypes.shape({
            type: PropTypes.string.isRequired,
            message: PropTypes.string.isRequired,
        }),
        loading: PropTypes.bool,
    };

    componentWillMount() {
        this.setState({
            formValid: false,
        })
    }

    render() {
        const {onFormSubmit, status, loading} = this.props;

        return (
            <div>
                <h1>
                    <strong>Placene</strong>volani.cz
                </h1>
                <p className="lead">
                    <FormattedMessage id="forgotten_password.motto" defaultMessage="Recovery of a forgotten password"/>
                </p>

                {!status &&
                <Formsy onValidSubmit={onFormSubmit} onValid={() => this.setState({formValid: true})}
                        onInvalid={() => this.setState({formValid: false})} className="form">
                    <InputFormGroup type="email" name="email" id="email"  validations="isEmail" required
                                    validationErrors={{
                                        isEmail: (<FormattedMessage id="form.error.is_email"
                                                                    defaultMessage="Email is not valid"/>)
                                    }}
                                    label={(<FormattedMessage id="forgotten_password.email_label" defaultMessage="E-mail address associated with your account"/>)}
                    />

                    <Button disabled={!this.state.formValid || loading} type="submit" block className="btn-clickable">
                        {loading &&
                        <span className="pr-3">
                                <Loading inline small/>
                            </span>
                        }
                        <FormattedMessage id="forgotten_password.form.submit" defaultMessage="Dispatch a link to change your password"/>
                    </Button>
                </Formsy>
                }
                {status &&
                    <Col md={{ size: 4, offset: 4 }} style={{ textAlign: 'center' }}>
                        <Alert color={status.type}>
                            {status.message}
                        </Alert>
                    </Col>
                }
            </div>
        )
    }
}

export default ForgottenPassword;


// WEBPACK FOOTER //
// ./src/containers/ForgottenPassword/ForgottenPassword.jsx